import React, { Component } from "react";
import PropTypes from "prop-types";
import { defineMessages, injectIntl } from "react-intl";
import _ from "lodash";
import Styled from "./styles";

const intlMessages = defineMessages({
  legendTitle: {
    id: "app.meeting-ended.rating.legendLabel",
    description: "label for star feedback legend",
  },
  starLabel: {
    id: "app.meeting-ended.rating.starLabel",
    description: "label for feedback stars",
  },
});

class Rating extends Component {
  clickStar = (value) => {
    const { onRate } = this.props;
    onRate(value); // will be 1, 2, 3, 4, or 5
  };

  renderStars(num) {
    const { intl, hideLabel } = this.props;

    return (
      <Styled.StarRating>
        <fieldset>
          {!hideLabel && <Styled.Legend>Tutor feedback rating</Styled.Legend>}
          {_.range(1, num + 1).reverse().map((i) => (
            <React.Fragment key={i}>
              <input
                type="radio"
                id={`${i}star`}
                name="rating"
                value={i}
                onChange={() => this.clickStar(i)}
              />
              <label
                htmlFor={`${i}star`}
                aria-label={`${i} ${intl.formatMessage(intlMessages.starLabel)}`}
              />
            </React.Fragment>
          ))}
        </fieldset>
      </Styled.StarRating>
    );
  }

  render() {
    const { total } = this.props;
    return <Styled.Father>{this.renderStars(total)}</Styled.Father>;
  }
}

Rating.propTypes = {
  intl: PropTypes.object.isRequired,
  onRate: PropTypes.func.isRequired,
  total: PropTypes.number.isRequired, // changed to number
  hideLabel: PropTypes.bool, // hide the "Tutor feedback rating" label
};

Rating.defaultProps = {
  total: 5,
  hideLabel: false,
};

export default injectIntl(Rating);
